import { ANYWHERE_PLACE_ID } from 'constants/search'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'
import LayoutContainer from 'components/Common/LayoutContainer'
import ImageHero from 'components/Common/ImageHero'
import HolidayTypeLandingPageHeroHeading from './HolidayTypeLandingPageHeroHeading'

const HeroImage = styled(ImageHero)`
  background-color: ${props => props.theme.palette.brand.primary.normal};
  max-height: ${rem(400)};
`

const HeroDefault = styled.div`
  background-color: ${props => props.theme.palette.brand.primary.normal};
  max-height: ${rem(400)};
`

interface Props {
  destinationId: string
  destination: string
  holidayType: string
  validHolidayType: boolean
}

export function HolidayTypeLandingPageHero({ destinationId, destination, holidayType, validHolidayType }: Props) {
  function getImageId() {
    switch (holidayType) {
      case 'Family friendly':
        return 'holidayType.familyFriendly'
      case 'Honeymoon':
      case 'Adults only':
      case 'Romantic':
        return 'holidayType.couples'
      default:
        return undefined
    }
  }
  const imageId = getImageId()
  const hasImage = imageId !== undefined
  const anywhereDestinationId = destinationId === ANYWHERE_PLACE_ID
  const validDestination = destinationId && !anywhereDestinationId

  const showResultsFilteredByHolidayTypeAndDestination = !!(validHolidayType && validDestination)
  const showResultsFilteredByHolidayType = !!(validHolidayType && !validDestination)
  const showResultsFilteredByDestination = !!(!validHolidayType && validDestination)
  const showUnfilteredResults = !!(!validHolidayType && !validDestination)

  return (
    <>
      {hasImage &&
        <HeroImage
          id={imageId}
          brightness={-30}
          aria-hidden="true"
          gravity="auto"
          color="pink"
        >
          <LayoutContainer>
            <HolidayTypeLandingPageHeroHeading
              showResultsFilteredByHolidayTypeAndDestination={showResultsFilteredByHolidayTypeAndDestination}
              showResultsFilteredByHolidayType={showResultsFilteredByHolidayType}
              showResultsFilteredByDestination={showResultsFilteredByDestination}
              showUnfilteredResults={showUnfilteredResults}
              holidayType={holidayType}
              destination={destination}
              hasImage={hasImage}
            />
          </LayoutContainer>
        </HeroImage>}
      {!hasImage &&
        <HeroDefault>
          <LayoutContainer>
            <HolidayTypeLandingPageHeroHeading
              showResultsFilteredByHolidayTypeAndDestination={showResultsFilteredByHolidayTypeAndDestination}
              showResultsFilteredByHolidayType={showResultsFilteredByHolidayType}
              showResultsFilteredByDestination={showResultsFilteredByDestination}
              showUnfilteredResults={showUnfilteredResults}
              holidayType={holidayType}
              destination={destination}
              hasImage={hasImage}
            />
          </LayoutContainer>
        </HeroDefault>}
    </>
  )
}
